import AnchorLink from "@bmi-digital/components/anchor-link";
import Typography from "@bmi-digital/components/typography";
import React, { useMemo } from "react";
import getRecaptchaPrivacyContent, {
  RecaptchaPolicyContentType
} from "./RecaptchaContentProvider";
import { useSiteContext } from "./Site";

type Props = {
  className?: string;
  testId?: string;
};

const RecaptchaPrivacyLinks = (props: Props) => {
  const { countryCode } = useSiteContext();
  const { className, testId } = props;
  const availableTestId = testId ? { "data-testid": testId } : {};

  return useMemo(() => {
    const recaptchaContent: RecaptchaPolicyContentType =
      getRecaptchaPrivacyContent(countryCode);
    const privacyPolicyUrl = recaptchaContent.privacyPolicyUrl;
    const privacyPloicyText = recaptchaContent.privacyPloicyText;
    const termsOfServiceUrl = recaptchaContent.termsOfServiceUrl;
    const termsOfServiceText = recaptchaContent.termsOfServiceText;

    return (
      <Typography
        className={className ? className : "RecaptchaPrivacyLinks"}
        {...availableTestId}
      >
        {recaptchaContent.startText}
        <AnchorLink
          href={privacyPolicyUrl}
          external
          data-testid={"recaptcha-privacy-policy-link"}
          gtm={{
            id: "cta-click1",
            action: privacyPolicyUrl,
            label: privacyPloicyText
          }}
        >
          {privacyPloicyText}
        </AnchorLink>
        {recaptchaContent.andText}
        <AnchorLink
          href={termsOfServiceUrl}
          external
          data-testid={"recaptcha-terms-of-service-link"}
          gtm={{
            id: "cta-click1",
            action: termsOfServiceUrl,
            label: termsOfServiceText
          }}
        >
          {termsOfServiceText}
        </AnchorLink>
        {recaptchaContent.endText}
      </Typography>
    );
  }, [countryCode, className]);
};

export default RecaptchaPrivacyLinks;
